// extracted by mini-css-extract-plugin
export default {"heru":"Heru_heru__+FYz8","content":"Heru_content__wkDV4","text":"Heru_text__tKlFG","imageCont":"Heru_imageCont__GzEzs","card_img":"Heru_card_img__RxR7q"};